var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form', {
    staticClass: "event-flow-form"
  }, [_c('div', {
    staticClass: "event-flow-form-row"
  }, [_c('form-selector', {
    staticClass: "step-selector mb-0",
    attrs: {
      "id": "event-flow-step",
      "label": _vm.$t('event-flow.form.step'),
      "options": _vm.eventFlowStepValues
    },
    model: {
      value: _vm.formData.step,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "step", $$v);
      },
      expression: "formData.step"
    }
  }), _c('div', {
    staticClass: "date-group"
  }, [_c('label', {
    staticClass: "mb-2",
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.form.day')) + " ")]), _c('div', {
    staticClass: "date-row"
  }, [_c('button', {
    staticClass: "date-arrow-button",
    attrs: {
      "type": "button",
      "aria-label": _vm.$t('event-flow.form.previous-day')
    },
    on: {
      "click": function ($event) {
        return _vm.stepDay(false);
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "date-arrow-icon",
    attrs: {
      "icon": "arrow-left"
    }
  })], 1), _c('date-time-picker', {
    staticClass: "date-picker mb-0",
    attrs: {
      "id": "event-flow-start-time-group",
      "mode": "date"
    },
    model: {
      value: _vm.formData.date,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "date", $$v);
      },
      expression: "formData.date"
    }
  }), _c('button', {
    staticClass: "date-arrow-button",
    attrs: {
      "type": "button",
      "aria-label": _vm.$t('event-flow.form.next-day')
    },
    on: {
      "click": function ($event) {
        return _vm.stepDay(true);
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "date-arrow-icon",
    attrs: {
      "icon": "arrow-right"
    }
  })], 1)], 1)]), _c('date-time-picker', {
    staticClass: "time-picker mb-0",
    attrs: {
      "id": "event-flow-start-time-group",
      "mode": "time",
      "label": _vm.$t('event-flow.form.start-time'),
      "max-date": _vm.dateForm.endTime
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.dateForm.startTime.maxValue ? _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(" " + _vm._s(_vm.$t('validation.start-date.before-end')) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.dateForm.startTime,
      callback: function ($$v) {
        _vm.$set(_vm.dateForm, "startTime", $$v);
      },
      expression: "dateForm.startTime"
    }
  }), _c('date-time-picker', {
    staticClass: "time-picker mb-0",
    attrs: {
      "id": "event-flow-end-time-group",
      "mode": "time",
      "label": _vm.$t('event-flow.form.end-time'),
      "min-date": _vm.dateForm.startTime
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.dateForm.endTime.minValue ? _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(" " + _vm._s(_vm.$t('validation.end-date.after-start')) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.dateForm.endTime,
      callback: function ($$v) {
        _vm.$set(_vm.dateForm, "endTime", $$v);
      },
      expression: "dateForm.endTime"
    }
  }), _c('div', {
    staticClass: "checkbox-group"
  }, [_c('form-checkbox', {
    staticClass: "checkbox-item",
    attrs: {
      "id": "time",
      "label": _vm.$t('event-flow.form.show-time')
    },
    model: {
      value: _vm.extraFunctionFormData.showTime,
      callback: function ($$v) {
        _vm.$set(_vm.extraFunctionFormData, "showTime", $$v);
      },
      expression: "extraFunctionFormData.showTime"
    }
  }), _c('form-checkbox', {
    staticClass: "checkbox-item",
    attrs: {
      "id": "brief",
      "label": _vm.$t('event-flow.form.show-brief')
    },
    model: {
      value: _vm.extraFunctionFormData.showBrief,
      callback: function ($$v) {
        _vm.$set(_vm.extraFunctionFormData, "showBrief", $$v);
      },
      expression: "extraFunctionFormData.showBrief"
    }
  }), _c('form-checkbox', {
    staticClass: "checkbox-item",
    attrs: {
      "id": "legend",
      "label": _vm.$t('event-flow.form.show-legend')
    },
    model: {
      value: _vm.extraFunctionFormData.showLegend,
      callback: function ($$v) {
        _vm.$set(_vm.extraFunctionFormData, "showLegend", $$v);
      },
      expression: "extraFunctionFormData.showLegend"
    }
  }), _c('form-checkbox', {
    staticClass: "checkbox-item",
    attrs: {
      "id": "timeline",
      "label": _vm.$t('event-flow.form.show-timeline')
    },
    model: {
      value: _vm.extraFunctionFormData.showTimeline,
      callback: function ($$v) {
        _vm.$set(_vm.extraFunctionFormData, "showTimeline", $$v);
      },
      expression: "extraFunctionFormData.showTimeline"
    }
  })], 1), _c('div', {
    staticClass: "event-flow-form-actions"
  }, [_c('event-flow-filter', {
    attrs: {
      "responsibles": _vm.responsibles,
      "locations": _vm.locations,
      "topics": _vm.topics
    },
    model: {
      value: _vm.filterFormData,
      callback: function ($$v) {
        _vm.filterFormData = $$v;
      },
      expression: "filterFormData"
    }
  }), _c('event-flow-switch', {
    model: {
      value: _vm.eventFlowSelectedValue,
      callback: function ($$v) {
        _vm.eventFlowSelectedValue = $$v;
      },
      expression: "eventFlowSelectedValue"
    }
  }), _c('router-link', {
    attrs: {
      "to": {
        name: 'MasterData',
        params: {
          id: _vm.eventId
        }
      }
    }
  }, [_c('b-button', {
    staticClass: "btn-locations",
    attrs: {
      "variant": "white"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.form.locations')) + " ")])], 1), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.sheet-modal",
      modifiers: {
        "sheet-modal": true
      }
    }],
    staticClass: "btn-share",
    attrs: {
      "variant": "white"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.form.manage-sheet')) + " ")])], 1)], 1), _c('custom-modal', {
    attrs: {
      "id": "sheet-modal",
      "title": _vm.$t('sheet.popup.title')
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('sheet-modal', {
          attrs: {
            "sheet": _vm.getSheet
          }
        })];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }